import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './AdminDemoRequests.css';
import { FiCalendar, FiMail, FiPhone, FiBriefcase, FiUser, FiClock, FiCheckCircle, FiXCircle, FiEdit2, FiTrash2, FiEye, FiFilter, FiDownload, FiPhoneCall } from 'react-icons/fi';
import { getAllDemoRequests, updateDemoRequest, deleteDemoRequest, getDemoRequestStats } from '../../services/demoRequestService';

const AdminDemoRequests = () => {
  const [demoRequests, setDemoRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [stats, setStats] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  });


  useEffect(() => {
    fetchDemoRequests();
        fetchStats();

  }, [filter, pagination.page]);

  const fetchDemoRequests = async () => {
    try {
      const token = localStorage.getItem('adminToken');
       setLoading(true);
      const params = {
        page: pagination.page,
        limit: pagination.limit
      };
      
      if (filter !== 'all') {
        params.status = filter;
      }

      const response = await axios.get('http://dev.whiterobe.in:5001/api/v1/admin/demo-requests', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setDemoRequests(response.data.demoRequests || []);

       if (response.pagination) {
        setPagination(prev => ({
          ...prev,
          total: response.pagination.total,
          totalPages: response.pagination.totalPages
        }));
      }
      
    } catch (error) {
      console.error('Error fetching demo requests:', error);
      toast.error('Failed to load demo requests');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, newStatus) => {
    try {
      const token = localStorage.getItem('adminToken');
      await axios.patch(
        `http://dev.whiterobe.in:5001/api/v1/admin/demo-requests/${id}/status`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Status updated successfully');
      fetchDemoRequests();
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Failed to update status');
    }
  };

    const fetchStats = async () => {
      try {
        const response = await getDemoRequestStats();
        setStats(response.stats);
      } catch (error) {
        console.error('Failed to fetch stats:', error);
      }
    };

  const filteredRequests = demoRequests.filter(request => {
    const matchesFilter = filter === 'all' || request.status === filter;
    const matchesSearch =
      request.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      request.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      request.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      request.company?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const getStatusBadgeClass = (status) => {
    const statusMap = {
      pending: 'badge-warning',
      confirmed: 'badge-success',
      completed: 'badge-info',
      cancelled: 'badge-danger'
    };
    return statusMap[status] || 'badge-secondary';
  };


   
  
    const handleStatusUpdate = async (id, newStatus) => {
      try {
        await updateDemoRequest(id, { status: newStatus });
        toast.success('Status updated successfully');
        fetchDemoRequests();
        fetchStats()
        setShowModal(false);
      } catch (error) {
        toast.error('Failed to update status');
        console.error(error);
      }
    };
  
    const handleDelete = async (id) => {
      if (window.confirm('Are you sure you want to delete this demo request?')) {
        try {
          await deleteDemoRequest(id);
          fetchStats()
          toast.success('Demo request deleted successfully');
          fetchDemoRequests();
        } catch (error) {
          toast.error('Failed to delete demo request');
          console.error(error);
        }
      }
    };
  
    const handleViewDetails = (request) => {
      setSelectedRequest(request);
      setShowModal(true);
    };
  
    const getStatusBadge = (status) => {
      const statusConfig = {
        pending: { bg: 'bg-yellow-100', text: 'text-yellow-800', icon: FiClock },
        confirmed: { bg: 'bg-blue-100', text: 'text-blue-800', icon: FiCheckCircle },
        completed: { bg: 'bg-green-100', text: 'text-green-800', icon: FiCheckCircle },
        cancelled: { bg: 'bg-red-100', text: 'text-red-800', icon: FiXCircle }
      };
  
      const config = statusConfig[status] || statusConfig.pending;
      const Icon = config.icon;
  
      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
          <Icon className="w-3 h-3 mr-1" />
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      );
    };
  
    

  // if (loading) {
  //   return <div className="admin-demo-requests"><div className="loading">Loading...</div></div>;
  // }

  // return (
  //   <div className="admin-demo-requests">
  //     <div className="page-header">
  //       <h1>Demo Requests</h1>
  //       <div className="header-stats">
  //         <div className="stat-card">
  //           <span className="stat-label">Total</span>
  //           <span className="stat-value">{demoRequests.length}</span>
  //         </div>
  //         <div className="stat-card">
  //           <span className="stat-label">Pending</span>
  //           <span className="stat-value">{demoRequests.filter(r => r.status === 'pending').length}</span>
  //         </div>
  //         <div className="stat-card">
  //           <span className="stat-label">Confirmed</span>
  //           <span className="stat-value">{demoRequests.filter(r => r.status === 'confirmed').length}</span>
  //         </div>
  //       </div>
  //     </div>

  //     <div className="filters-section">
  //       <div className="search-box">
  //         <input
  //           type="text"
  //           placeholder="Search by name, email, or company..."
  //           value={searchTerm}
  //           onChange={(e) => setSearchTerm(e.target.value)}
  //         />
  //       </div>
  //       <div className="filter-buttons">
  //         <button 
  //           className={filter === 'all' ? 'active' : ''} 
  //           onClick={() => setFilter('all')}
  //         >
  //           All
  //         </button>
  //         <button 
  //           className={filter === 'pending' ? 'active' : ''} 
  //           onClick={() => setFilter('pending')}
  //         >
  //           Pending
  //         </button>
  //         <button 
  //           className={filter === 'confirmed' ? 'active' : ''} 
  //           onClick={() => setFilter('confirmed')}
  //         >
  //           Confirmed
  //         </button>
  //         <button 
  //           className={filter === 'completed' ? 'active' : ''} 
  //           onClick={() => setFilter('completed')}
  //         >
  //           Completed
  //         </button>
  //         <button 
  //           className={filter === 'cancelled' ? 'active' : ''} 
  //           onClick={() => setFilter('cancelled')}
  //         >
  //           Cancelled
  //         </button>
  //       </div>
  //     </div>

  //     <div className="table-container">
  //       <table className="demo-requests-table">
  //         <thead>
  //           <tr>
  //             <th>Name</th>
  //             <th>Email</th>
  //             <th>Company</th>
  //             <th>Phone</th>
  //             <th>Preferred Date</th>
  //             <th>Status</th>
  //             <th>Created</th>
  //             <th>Actions</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {filteredRequests.length === 0 ? (
  //             <tr>
  //               <td colSpan="8" className="no-data">No demo requests found</td>
  //             </tr>
  //           ) : (
  //             filteredRequests.map(request => (
  //               <tr key={request.id}>
  //                 <td>{request.first_name} {request.last_name}</td>
  //                 <td>{request.email}</td>
  //                 <td>{request.company || 'N/A'}</td>
  //                 <td>{request.phone || 'N/A'}</td>
  //                 <td>{request.preferred_date ? new Date(request.preferred_date).toLocaleDateString() : 'N/A'}</td>
  //                 <td>
  //                   <span className={`status-badge ${getStatusBadgeClass(request.status)}`}>
  //                     {request.status}
  //                   </span>
  //                 </td>
  //                 <td>{new Date(request.created_at).toLocaleDateString()}</td>
  //                 <td>
  //                   <div className="action-buttons">
  //                     {request.status === 'pending' && (
  //                       <>
  //                         <button 
  //                           className="btn-confirm"
  //                           onClick={() => updateStatus(request.id, 'confirmed')}
  //                         >
  //                           Confirm
  //                         </button>
  //                         <button 
  //                           className="btn-cancel"
  //                           onClick={() => updateStatus(request.id, 'cancelled')}
  //                         >
  //                           Cancel
  //                         </button>
  //                       </>
  //                     )}
  //                     {request.status === 'confirmed' && (
  //                       <button 
  //                         className="btn-complete"
  //                         onClick={() => updateStatus(request.id, 'completed')}
  //                       >
  //                         Complete
  //                       </button>
  //                     )}
  //                   </div>
  //                 </td>
  //               </tr>
  //             ))
  //           )}
  //         </tbody>
  //       </table>
  //     </div>
  //   </div>
  // );


  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Demo Requests</h1>
        <p className="text-gray-600">Manage and track all demo requests from potential customers</p>
      </div>

      {/* Stats Cards */}
      {stats && (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Requests</p>
                <p className="text-2xl font-bold text-gray-900">{stats.total || 0}</p>
              </div>
              <div className="bg-blue-100 rounded-full p-3">
                <FiCalendar className="w-6 h-6 text-blue-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pending</p>
                <p className="text-2xl font-bold text-yellow-600">{stats.pending || 0}</p>
              </div>
              <div className="bg-yellow-100 rounded-full p-3">
                <FiClock className="w-6 h-6 text-yellow-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Confirmed</p>
                <p className="text-2xl font-bold text-blue-600">{stats.confirmed || 0}</p>
              </div>
              <div className="bg-blue-100 rounded-full p-3">
                <FiCheckCircle className="w-6 h-6 text-blue-600" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Completed</p>
                <p className="text-2xl font-bold text-green-600">{stats.completed || 0}</p>
              </div>
              <div className="bg-green-100 rounded-full p-3">
                <FiCheckCircle className="w-6 h-6 text-green-600" />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Filters and Search */}
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center space-x-4">
            <FiFilter className="text-gray-400" />
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>

          <div className="flex-1 max-w-md">
            <input
              type="text"
              placeholder="Search by name, email, or company..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Demo Requests Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        ) : filteredRequests.length === 0 ? (
          <div className="text-center py-12">
            <FiCalendar className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">No demo requests</h3>
            <p className="mt-1 text-sm text-gray-500">No demo requests found matching your criteria.</p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Contact
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Company
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Preferred Date/Time
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredRequests.map((request) => (
                    <tr key={request.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                            <FiUser className="h-5 w-5 text-blue-600" />
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">
                              {request.firstName} {request.lastName}
                            </div>
                            <div className="text-sm text-gray-500 flex items-center">
                              <FiMail className="w-3 h-3 mr-1" />
                              {request.email}
                            </div>
                            <div className="text-sm text-gray-500 flex items-center">
                              <FiPhoneCall className="w-3 h-3 mr-1" />
                              {request.phone}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">{request.company}</div>
                        <div className="text-sm text-gray-500">{request.companySize}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 flex items-center">
                          <FiCalendar className="w-4 h-4 mr-1" />
                          {new Date(request.preferredDate).toLocaleDateString()}
                        </div>
                        <div className="text-sm text-gray-500 flex items-center">
                          <FiClock className="w-4 h-4 mr-1" />
                          {request.preferredTime}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {getStatusBadge(request.status)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleViewDetails(request)}
                            className="text-blue-600 hover:text-blue-900"
                            title="View Details"
                          >
                            <FiEye className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() => handleDelete(request.id)}
                            className="text-red-600 hover:text-red-900"
                            title="Delete"
                          >
                            <FiTrash2 className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() =>handleStatusUpdate(request.id, 'confirmed')}
                            className="text-red-600 hover:text-red-900"
                            title="Approve"
                          >
                            <FiCheckCircle className="w-6 h-6 text-green-600" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pagination.totalPages > 1 && (
              <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div className="flex-1 flex justify-between sm:hidden">
                  <button
                    onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                    disabled={pagination.page === 1}
                    className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                    disabled={pagination.page === pagination.totalPages}
                    className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm text-gray-700">
                      Showing <span className="font-medium">{(pagination.page - 1) * pagination.limit + 1}</span> to{' '}
                      <span className="font-medium">
                        {Math.min(pagination.page * pagination.limit, pagination.total)}
                      </span>{' '}
                      of <span className="font-medium">{pagination.total}</span> results
                    </p>
                  </div>
                  <div>
                    <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
                      <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                        disabled={pagination.page === 1}
                        className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                      >
                        Previous
                      </button>
                      <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                        disabled={pagination.page === pagination.totalPages}
                        className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                      >
                        Next
                      </button>
                    </nav>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Detail Modal */}
      {showModal && selectedRequest && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-full max-w-2xl shadow-lg rounded-md bg-white">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-900">Demo Request Details</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-400 hover:text-gray-500"
              >
                <FiXCircle className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-4">
              {/* Contact Information */}
              <div className="border-b pb-4">
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Contact Information</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500">Name</p>
                    <p className="text-sm font-medium">{selectedRequest.firstName} {selectedRequest.lastName}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Email</p>
                    <p className="text-sm font-medium">{selectedRequest.email}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Phone</p>
                    <p className="text-sm font-medium">{selectedRequest.phone || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Job Title</p>
                    <p className="text-sm font-medium">{selectedRequest.jobTitle || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Company Information */}
              <div className="border-b pb-4">
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Company Information</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500">Company</p>
                    <p className="text-sm font-medium">{selectedRequest.company}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Company Size</p>
                    <p className="text-sm font-medium">{selectedRequest.companySize || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Industry</p>
                    <p className="text-sm font-medium">{selectedRequest.industry || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Schedule Information */}
              <div className="border-b pb-4">
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Schedule Information</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500">Preferred Date</p>
                    <p className="text-sm font-medium">{new Date(selectedRequest.preferredDate).toLocaleDateString()}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Preferred Time</p>
                    <p className="text-sm font-medium">{selectedRequest.preferredTime}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Timezone</p>
                    <p className="text-sm font-medium">{selectedRequest.timezone}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Status</p>
                    <p className="text-sm font-medium">{getStatusBadge(selectedRequest.status)}</p>
                  </div>
                </div>
              </div>

              {/* Message */}
              {selectedRequest.message && (
                <div className="border-b pb-4">
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">Message</h4>
                  <p className="text-sm text-gray-600">{selectedRequest.message}</p>
                </div>
              )}

              {/* Status Update */}
              <div>
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Update Status</h4>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleStatusUpdate(selectedRequest.id, 'pending')}
                    className="px-4 py-2 bg-yellow-100 text-yellow-800 rounded-lg hover:bg-yellow-200 text-sm"
                  >
                    Pending
                  </button>
                  <button
                    onClick={() => handleStatusUpdate(selectedRequest.id, 'confirmed')}
                    className="px-4 py-2 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200 text-sm"
                  >
                    Confirmed
                  </button>
                  <button
                    onClick={() => handleStatusUpdate(selectedRequest.id, 'completed')}
                    className="px-4 py-2 bg-green-100 text-green-800 rounded-lg hover:bg-green-200 text-sm"
                  >
                    Completed
                  </button>
                  <button
                    onClick={() => handleStatusUpdate(selectedRequest.id, 'cancelled')}
                    className="px-4 py-2 bg-red-100 text-red-800 rounded-lg hover:bg-red-200 text-sm"
                  >
                    Cancelled
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );


};

export default AdminDemoRequests;


